import { client as request } from "./request";

/**
 * 郵便番号から住所を取得する
 */
export async function getAddressFromPostcode(postcode: string) {
  const data = await request.get("get_address_from_postcode.php", {
    postcode
  });
  return data.address || "";
}

/**
 * 住所から緯度経度を取得する
 */
export async function getLatitudeAndLongitudeFromAddress(address: string) {
  const data = await request.get(
    "get_latitude_and_longitude_from_address.php",
    {
      address
    }
  );
  return data;
}
